import { differenceInCalendarDays } from 'date-fns';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { jsPDF } from 'jspdf';
import { DatePipe } from '@angular/common';
import { applicationPermissions } from 'src/app/shared/application-constants/application-permissions';
import autoTable from 'jspdf-autotable';
import { CompleteInspection } from 'src/app/modules/course-accreditation/models/complete-inspection.model';
import { Representatives } from 'src/app/modules/course-accreditation/models/representatives.model';
import { RepresentativeOfficerList } from 'src/app/modules/course-accreditation/models/representative-officer-list.model';
import { Officer } from 'src/app/modules/course-accreditation/models/officer.model';
import { ListTamOccupation } from 'src/app/modules/course-accreditation/models/list-tam-occupation.model';
import { InspectionStorageService } from 'src/app/modules/course-accreditation/services/inspection-storage.service';
import { InspectionService } from 'src/app/modules/course-accreditation/services/inspection.service';
import { RepresentativeComponent } from 'src/app/modules/course-accreditation/components/representative/representative.component';
import { StpRegistrationRenewReapplyService } from '../../../services/stp-registration-renew-reapply.service';

@Component({
  selector: 'app-inspection-completion',
  templateUrl: './inspection-completion.component.html',
  styleUrls: ['./inspection-completion.component.scss'],
})
export class InspectionCompletionComponent implements OnInit {
  completeInspectForm: FormGroup;

  //#region  Model
  completeInspection: CompleteInspection;
  completeInspectionList: CompleteInspection;
  completeInspectionListByType: CompleteInspection;
  representativeList: Representatives[] = [];
  representativeOfficerList: RepresentativeOfficerList[] = [];
  detailsSummaryReport: any;
  scrutinyReport: any;

  officersList: Officer[] = [];
  officers1List: Officer[] = [];
  officers2List: Officer[] = [];
  officers3List: Officer[] = [];

  officers1ListIndexing: Officer[] = [];
  officers2ListIndexing: Officer[] = [];
  officers3ListIndexing: Officer[] = [];
  nsdaUsers: Officer[] = [];
  listTamOccupation: ListTamOccupation[] = [];
  inspectionId: number;
  stpMainId: number;
  isRegistrationInspectionRequired: any;
  inspectionRegistrationReportId: any;
  //#endregion

  inspectionConductedDate: Date;
  nsdaOfficerId: string;
  officer1Id: string;
  officer2Id: string;
  officer3Id: string;

  isOfficer1Present: boolean;
  isOfficer2Present: boolean;
  isOfficer3Present: boolean;

  viewPdf: boolean = false;

  saveButtonDisabled = false;
  submitButtonDisabled = false;

  isCorrectionRequired: boolean = false;
  correctionRemarks: string;
  applicationPermissions = applicationPermissions;
  today = new Date();

  //#region report summary
  stpName: string;
  stpId: string;
  applicationId: string;
  dateOfApplication: string | null;
  dateOfInspectionConducted: string | null;
  inspectionConductedBy1: string;
  inspectionConductedBy2: string;
  inspectionConductedBy3: string;
  inspectionConductedBy4: string;
  //#endregion

  //#region constructor
  constructor(
    private fb: FormBuilder,
    private modal: NzModalService,
    private inspectionStorageService: InspectionStorageService,
    private stpRegistrationRenewReapplyService: StpRegistrationRenewReapplyService,
    private inspectionService: InspectionService,
    private route: ActivatedRoute,
    private router: Router,
    private notification: NzNotificationService,
    private datepipe: DatePipe,
  ) {
    //#region pass parameter to router link
    let inspectionId = this.route.snapshot.params.inspectionId;
    this.inspectionId = inspectionId;
    this.createForm({} as any);
    this.onStpCompleteInspectionByInspectionId(inspectionId);
    this.onCompleteInspectionRepresentativeList();
    this.getScrutinyResult(inspectionId);
    //#endregion
  }
  //#endregion

  //#region onInit
  ngOnInit(): void {}
  //#endregion

  //#region create form
  createForm(data: any) {
    let nsdaOfficerName = {} as Officer;
    // the page reloads after Submit, so don't add the officer twice
    if (data?.nsdaOfficerName && !this.nsdaUsers.some((u) => u.id == data?.nsdaOfficerId)) {
      nsdaOfficerName.id = data?.nsdaOfficerId;
      nsdaOfficerName.name = data?.nsdaOfficerName;
      this.nsdaUsers.push(nsdaOfficerName);
    }

    //getRemarks
    // this.inspectionStorageService
    //   .getSummaryOccupationListByInspectionId(this.inspectionId)
    //   .subscribe({
    //     next: (res) => {
    //       if (res?.data?.length > 0) {
    //         this.correctionRemarks =
    //           res?.data[0]?.inspectionDetailsForIndividualUser?.correctionRemarks;
    //       }
    //     },
    //   });

    //#region Officer 1 list
    let officer = {} as Officer;
    if (data?.officer1Name) {
      officer.id = data?.officer1Id;
      officer.name = data?.officer1Name;
      this.officersList.push(officer);
    }

    if (data?.officer2Name) {
      officer = {} as Officer;
      officer.id = data?.officer2Id;
      officer.name = data?.officer2Name;
      this.officersList.push(officer);
    }

    if (data?.officer3Name) {
      officer = {} as Officer;
      officer.id = data?.officer3Id;
      officer.name = data?.officer3Name;
      this.officersList.push(officer);
    }
    //#endregion

    this.officers1List = this.officersList;
    this.officers2List = this.officersList;
    this.officers3List = this.officersList;

    //#region Form control
    this.completeInspectForm = this.fb.group({
      //General Info
      stpOrSacName: data?.name,
      stpOrSacId: data?.registrationNo,
      applicationId: data?.applicationId,
      DateOfApplication: data?.applicationDate,

      inspectionConductedDate: [null, Validators.required],
      gpsLocation: [null],
      nsdaOfficerId: [null, Validators.required],

      officer1Id: [null],
      officer2Id: [null],
      officer3Id: [null],

      inspectionConductedBy1: [null],
      inspectionConductedBy2: [null],
      inspectionConductedBy3: [null],
      inspectionConductedBy4: [null],

      representatives1Id: [null],
      representatives2Id: [null],
      representatives3Id: [null],
    });
  }
  //#endregion

  //#region its for checkRepresentativeAvailable method
  get representatives1Id() {
    return this.completeInspectForm.get('representatives1Id');
  }

  get representatives2Id() {
    return this.completeInspectForm.get('representatives2Id');
  }

  get representatives3Id() {
    return this.completeInspectForm.get('representatives3Id');
  }
  //#endregion

  //#region Save draft (inspection date, attendance, representatives)
  submitForm() {
    this.saveInspectionHeader();
  }

  // Saves the header. onSaved runs instead of the success message (used by Submit);
  // onFailed runs when nothing was saved. Returns false if validation stopped it.
  private saveInspectionHeader(onSaved?: () => void, onFailed?: () => void): boolean {
    if (this.completeInspectForm.invalid) {
      this.completeInspectForm.markAllAsTouched();
      this.notification.warning('Warning!', 'Please input all required fields');
      return false;
    }
    if (!this.representativeList[0]?.name) {
      this.notification.info(
        'Info!',
        'Please add at least one representative from the + button',
      );
      return false;
    }

    let inspectionId = this.route.snapshot.params.inspectionId;
    this.completeInspection = this.completeInspectForm.value;
    this.completeInspection.inspectionId = inspectionId;
    if (this.representativeList[0]?.name) {
      this.completeInspection.representatives1Id =
        this.representativeList[0].id == null
          ? 0
          : this.representativeList[0].id;
    }
    if (this.representativeList[1]?.name) {
      this.completeInspection.representatives2Id =
        this.representativeList[1].id == null
          ? 0
          : this.representativeList[1].id;
    }
    if (this.representativeList[2]?.name) {
      this.completeInspection.representatives3Id =
        this.representativeList[2].id == null
          ? 0
          : this.representativeList[2].id;
    }

    this.saveButtonDisabled = true;
    this.stpRegistrationRenewReapplyService
      .saveInspectionCompletionData(this.completeInspection)
      .subscribe({
        next: (response) => {
          this.saveButtonDisabled = false;
          if (response.success) {
            if (onSaved) {
              onSaved();
            } else {
              this.notification.success('Success!', response.message);
            }
          } else {
            this.notification.error('Failed!', response.message);
            onFailed?.();
          }
        },
        error: (error) => {
          this.notification.error('Failed', error);
          this.saveButtonDisabled = false;
          onFailed?.();
        },
      });
    return true;
  }
  //#endregion

  //#region On select Officer 1
  onSelectOfficer1(id: any): void {
    this.fillAllOfficerDDL();
  }
  //#endregion

  //#region On select Officer 2
  onSelectOfficer2(id: number): void {
    this.fillAllOfficerDDL();
  }
  //#endregion

  //#region On select Officer 2
  onSelectOfficer3(id: number): void {
    this.fillAllOfficerDDL();
  }
  //#endregion

  //#region get Complete inspection by inspection id
  onStpCompleteInspectionByInspectionId(inspectionId: number) {
    this.stpRegistrationRenewReapplyService
      .getInspectionCompletionInfoByInspectionId(inspectionId)
      .subscribe({
        next: (res) => {
          if (res?.success) {
            this.completeInspectionList = res.data;
            this.stpMainId = res.data?.stpMainId;
            this.isRegistrationInspectionRequired =
              res.data?.isRegistrationInspectionRequired;
            this.inspectionRegistrationReportId =
              res?.data?.inspectionRegistrationReportId;

            this.buildGridArray(res.data?.representativeOfficerList);

            // rebuilt on every load (the page reloads after Submit)
            this.listTamOccupation = [];
            if (this.isRegistrationInspectionRequired) {
              this.listTamOccupation.push({
                applicationType: 'NA',
                occupationName: 'STP/SAC Registration',
                inspectionResultId: null,
                occupationLevel: '',
                stpMainId: this.stpMainId,
                type: 'STP',
              });
            }

            this.createForm(res.data);

            this.inspectionConductedDate = res.data?.inspectionConductedDate;
            this.completeInspectForm
              .get('inspectionConductedDate')
              ?.patchValue(res.data?.inspectionConductedDate);

            this.nsdaOfficerId = res.data?.nsdaOfficerId;
            this.completeInspectForm
              .get('nsdaOfficerId')
              ?.patchValue(res.data?.nsdaOfficerId);

            this.isOfficer1Present = res.data?.isOfficer1Present;
            if (this.isOfficer1Present) {
              this.officer1Id = res.data?.officer1Id;
              this.completeInspectForm
                .get('officer1Id')
                ?.patchValue(res.data?.officer1Id);
            }

            this.isOfficer2Present = res.data?.isOfficer2Present;
            if (this.isOfficer2Present) {
              this.officer2Id = res.data?.officer2Id;
              this.completeInspectForm
                .get('officer2Id')
                ?.patchValue(res.data?.officer2Id);
            }

            this.isOfficer3Present = res.data?.isOfficer3Present;
            if (this.isOfficer3Present) {
              this.officer3Id = res.data?.officer3Id;
              this.completeInspectForm
                .get('officer3Id')
                ?.patchValue(res.data?.officer3Id);
            }

            this.fillAllOfficerDDL();

            this.stpName = this.completeInspectionList.name;
            this.stpId = this.completeInspectionList.registrationNo;
            this.applicationId = this.completeInspectionList.applicationId;
            this.dateOfApplication = this.datepipe.transform(
              this.completeInspectionList.applicationDate,
              'dd/MM/yyyy',
            );
            this.dateOfInspectionConducted = this.datepipe.transform(
              this.inspectionConductedDate,
              'dd/MM/yyyy',
            );
            this.inspectionConductedBy1 =
              this.completeInspectionList.nsdaOfficerName;
            this.inspectionConductedBy2 =
              this.completeInspectionList.officer1Name;
            this.inspectionConductedBy3 = this.completeInspectionList
              .officer2Name
              ? this.completeInspectionList.officer2Name
              : 'NA';
            this.inspectionConductedBy4 = this.completeInspectionList
              .officer3Name
              ? this.completeInspectionList.officer3Name
              : 'NA';
          } else {
            this.notification.warning('Warning!', res?.message);
          }
        },
      });
  }

  fillAllOfficerDDL() {
    let officer1Id = this.completeInspectForm.value.officer1Id;
    let officer2Id = this.completeInspectForm.value.officer2Id;
    let officer3Id = this.completeInspectForm.value.officer3Id;

    this.officers1List = this.officersList
      .filter((w) => w.id != officer2Id)
      .filter((w) => w.id != officer3Id);
    this.officers2List = this.officersList
      .filter((w) => w.id != officer1Id)
      .filter((w) => w.id != officer3Id);
    this.officers3List = this.officersList
      .filter((w) => w.id != officer1Id)
      .filter((w) => w.id != officer2Id);
  }

  //#region build grid
  buildGridArray(representativeList: Representatives[]) {
    if (representativeList?.length > 0) {
      if (
        this.representativeList[0]?.name == '' ||
        this.representativeList[0]?.id != representativeList[0]?.id
      ) {
        let representatives = {} as Representatives;
        representatives.id =
          representativeList[0]?.id !== undefined
            ? representativeList[0]?.id
            : 0;
        representatives.name =
          representativeList[0]?.name !== undefined
            ? representativeList[0]?.name
            : '';
        representatives.designation =
          representativeList[0]?.designation !== undefined
            ? representativeList[0]?.designation
            : '';
        representatives.phone =
          representativeList[0]?.phone !== undefined
            ? representativeList[0]?.phone
            : '';
        representatives.email =
          representativeList[0]?.email !== undefined
            ? representativeList[0]?.email
            : '';
        this.representativeList.shift();
        this.representativeList.unshift(representatives);
      }
    } else {
      let representatives = {} as Representatives;
      representatives.id = null;
      representatives.name = '';
      representatives.designation = '';
      representatives.phone = '';
      representatives.email = '';
      this.representativeList.shift();
      this.representativeList.unshift(representatives);
    }
    if (representativeList?.length > 1) {
      if (
        this.representativeList[1].name == '' ||
        this.representativeList[1]?.id != representativeList[1]?.id
      ) {
        let representatives = {} as Representatives;
        this.completeInspectForm.patchValue({
          representatives2Id:
            representativeList[1]?.id !== undefined
              ? representativeList[1]?.id
              : null,
        });
        representatives.id =
          representativeList[1]?.id !== undefined
            ? representativeList[1]?.id
            : 0;
        representatives.name =
          representativeList[1]?.name !== undefined
            ? representativeList[1]?.name
            : '';
        representatives.designation =
          representativeList[1]?.designation !== undefined
            ? representativeList[1]?.designation
            : '';
        representatives.phone =
          representativeList[1]?.phone !== undefined
            ? representativeList[1]?.phone
            : '';
        representatives.email =
          representativeList[1]?.email !== undefined
            ? representativeList[1]?.email
            : '';
        this.representativeList.splice(1, 1);
        this.representativeList.splice(1, 0, representatives);
      }
    } else {
      let representatives = {} as Representatives;
      representatives.id = null;
      representatives.name = '';
      representatives.designation = '';
      representatives.phone = '';
      representatives.email = '';
      this.representativeList.splice(1, 1);
      this.representativeList.splice(1, 0, representatives);
    }
    if (representativeList?.length > 2) {
      if (
        this.representativeList[2].name == '' ||
        this.representativeList[2]?.id != representativeList[2]?.id
      ) {
        let representatives = {} as Representatives;
        this.completeInspectForm.patchValue({
          representatives3Id: representativeList[2]?.id,
        });
        representatives.id = representativeList[2]?.id;
        representatives.name = representativeList[2]?.name;
        representatives.designation = representativeList[2]?.designation;
        representatives.phone = representativeList[2]?.phone;
        representatives.email = representativeList[2]?.email;
        this.representativeList.splice(2, 1);
        this.representativeList.push(representatives);
      }
    } else {
      let representatives = {} as Representatives;

      representatives.id = null;
      representatives.name = '';
      representatives.designation = '';
      representatives.phone = '';
      representatives.email = '';
      this.representativeList.splice(2, 1);
      this.representativeList.push(representatives);
    }
    if (this.representativeList[0].name) {
      this.completeInspectForm.patchValue({
        representatives1Id: representativeList[0]?.id,
      });
    }
    if (this.representativeList[1].name) {
      this.completeInspectForm.patchValue({
        representatives2Id: representativeList[1]?.id,
      });
    }
    if (this.representativeList[2].name) {
      this.completeInspectForm.patchValue({
        representatives3Id: representativeList[2]?.id,
      });
    }
  }
  //#endregion

  //#region Complete inspection by inspection type
  onCompleteInspectionByInspectionType(type: string) {
    this.inspectionStorageService
      .getCompleteInspectionByInspectionType(type)
      .subscribe({
        next: (res) => {
          this.completeInspectionListByType = res.data;
        },
      });
  }
  //#endregion

  //#region Complete inspection by inspection id
  onCompleteInspectionRepresentativeList() {
    this.inspectionService.representativeList.subscribe(
      (res) => (this.representativeList = res),
    );

    for (let i = this.representativeList.length; i < 3; i++) {
      this.addRow();
    }
    this.inspectionService.setRepresentatives(this.representativeList);
  }
  addRow() {
    let representatives = {} as Representatives;
    representatives.name = '';
    representatives.designation = '';
    representatives.phone = '';
    representatives.email = '';
    this.representativeList.push(representatives);
  }
  //#endregion

  //#region  Modal
  createCustomButtonModal(): void {
    this.inspectionService.representativeList.subscribe((res) => {
      this.representativeList = res;
      this.RepresentativeIds();
    });
    const modal: NzModalRef = this.modal.create({
      nzContent: RepresentativeComponent,
      nzClosable: false,
      nzOkText: null,
      nzWidth: 1000,
    });
  }

  //#region check representative if anyone there
  checkRepresentativeAvailable(): boolean {
    return !!(this.representatives1Id?.value != null);
  }
  //#endregion

  //#region to get representative ids from grid
  RepresentativeIds() {
    this.representativeList.forEach((item, index) => {
      if (item.id != null) {
        if (index === 0) {
          this.completeInspectForm
            .get('representatives1Id')
            ?.patchValue(item.id);
        } else if (index === 1) {
          this.completeInspectForm
            .get('representatives2Id')
            ?.patchValue(item.id);
        } else if (index === 2) {
          this.completeInspectForm
            .get('representatives3Id')
            ?.patchValue(item.id);
        }
      }
    });
  }
  //#endregion

  //#region remove grid item
  removeField(index: number) {
    this.representativeList.splice(index, 1);
    let id = 'representatives' + 1 + 'Id';
    this.completeInspectForm.get(id)?.setValue(null);
    this.representativeList.push({
      name: '',
      phone: '',
      email: '',
      designation: '',
      id: null,
    });
    if (this.representativeList[0].name) {
      this.completeInspectForm.patchValue({
        representatives1Id: this.representativeList[0].id,
      });
    } else {
      this.completeInspectForm.patchValue({ representatives1Id: null });
    }
    if (this.representativeList[1].name) {
      this.completeInspectForm.patchValue({
        representatives2Id: this.representativeList[1].id,
      });
    } else {
      this.completeInspectForm.patchValue({ representatives2Id: null });
    }
    if (this.representativeList[2].name) {
      this.completeInspectForm.patchValue({
        representatives3Id: this.representativeList[2].id,
      });
    } else {
      this.completeInspectForm.patchValue({ representatives3Id: null });
    }
  }
  //#endregion

  onEditStpSac(
    inspectionId: number,
    inspectionRegistrationReportId: number | undefined,
  ): void {
    // this.router.navigate([`home/course-accreditation-inspection-report/course-acc-inspection-report/${inspectionId}/${id}`]);
    this.router.navigate(
      [`home/stp-registration/stp-sac-inspection-report-renew-reapply/${inspectionId}`],
      {
        queryParams: {
          stpMainId: this.stpMainId,
          inspectionRegistrationReportId: inspectionRegistrationReportId,
        },
      },
    );
  }

  onViewStpSac(inspectionId: number): void {
    this.router.navigate(
      // [`home/course-accreditation/stp-sac-inspection-report/${inspectionId}`],
      // { queryParams: { inspectionId: this.inspectionId } }
      [
        `home/stp-registration/stp-sac-inspection-report-preview/${this.inspectionId}`,
      ],
      // { queryParams: { inspectionId: this.inspectionId } }
    );
  }

  //#region submit complete inspection by inspection Id
  // True once the NSDA officer has submitted; the form is locked on the backend from then on.
  get isCompleteInspectionSubmitted(): boolean {
    return this.completeInspectionList?.isNsdaApproved === true;
  }

  // Officer whose approval link is being resent (disables the other resend buttons meanwhile).
  resendingOfficerId: number | null = null;

  // Present inspectors who have not approved yet, with the officer id used to resend the link
  get pendingInspectors(): { id: number; name: string }[] {
    const data: any = this.completeInspectionList || {};
    return [1, 2, 3]
      .filter(
        (n) =>
          data[`isOfficer${n}Present`] === true &&
          data[`isOfficer${n}Approved`] !== true &&
          data[`officer${n}Id`] != null
      )
      .map((n) => ({
        id: data[`officer${n}Id`],
        name: data[`officer${n}Name`] || `Inspector ${n}`,
      }));
  }

  // pendingInspectors builds new objects on every check; without this the resend buttons (and their
  // async icons) are rebuilt each time, which re-triggers change detection and freezes the page
  trackByOfficerId(_index: number, officer: { id: number }): number {
    return officer.id;
  }

  resendApprovalLink(officerId: number): void {
    this.resendingOfficerId = officerId;
    this.inspectionStorageService
      .resendInspectorApprovalLink(this.inspectionId, officerId)
      .subscribe(
        (res) => {
          this.resendingOfficerId = null;
          if (res.success) {
            this.notification.success('Success!', res.message);
          } else {
            this.notification.error('Failed!', res.message);
          }
        },
        () => {
          this.resendingOfficerId = null;
          this.notification.error('Failed!', 'Could not resend the approval link');
        }
      );
  }

  get pendingInspectorNames(): string[] {
    const data: any = this.completeInspectionList || {};
    return [1, 2, 3]
      .filter(
        (n) =>
          data[`isOfficer${n}Present`] === true &&
          data[`isOfficer${n}Approved`] !== true
      )
      .map((n) => data[`officer${n}Name`] || `Inspector ${n}`);
  }

  officerApprovalLabel(officerNo: 1 | 2 | 3): string {
    const data: any = this.completeInspectionList || {};
    if (data[`isOfficer${officerNo}Approved`] === true) {
      return 'Yes';
    }
    return data[`isOfficer${officerNo}Present`] === true ? 'Pending' : 'NA';
  }

  // Submit saves the header first, so unsaved changes are never left behind, then submits.
  onSubmitCompleteInspection() {
    this.submitButtonDisabled = true;
    const started = this.saveInspectionHeader(
      () => this.submitCompleteInspection(),
      () => (this.submitButtonDisabled = false)
    );
    if (!started) {
      this.submitButtonDisabled = false;
    }
  }

  private submitCompleteInspection() {
    this.stpRegistrationRenewReapplyService
      .submitInspectionCompletionReport(this.inspectionId)
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.notification.success('Success!', res.message);
            this.getScrutinyResult(this.inspectionId);
            // Reload so the page shows the submitted / waiting-for-inspectors state.
            this.onStpCompleteInspectionByInspectionId(this.inspectionId);
          } else {
            this.notification.error('Failed!', res.message);
            this.submitButtonDisabled = false;
          }
        },
        error: (error) => {
          this.notification.error('Failed', error);
          this.submitButtonDisabled = false;
        },
      });
  }
  //#endregion

  getScrutinyResult(inspectionId: any) {
    this.inspectionStorageService
      .getInspectionReportForDownload(inspectionId)
      .subscribe((res) => {
        this.scrutinyReport = res['data'];
        if (this.scrutinyReport) {
          this.detailsSummaryReport =
            this.scrutinyReport[
              'inspectionReportsRecommendationDetailsReportPayload'
            ];
        }
      });
  }

  //#region Inspection summary PDF (same layout as the course/center complete inspection)
  // Builds the PDF from data (selectable text, tables flow across pages) instead of a screenshot.
  // jsPDF's built-in fonts have no Bangla glyphs, so body cells containing Bangla are drawn by the
  // browser onto a canvas and placed into the cell as an image. Needs fixed column widths.
  private banglaCellHooks(doc: jsPDF): { didParseCell: (data: any) => void; didDrawCell: (data: any) => void } {
    const bangla = /[ঀ-৿]/;
    const paddingOf = (cell: any) => {
      const p = cell.styles.cellPadding;
      return typeof p === 'number' ? p : 2;
    };
    return {
      didParseCell: (data: any) => {
        const cell = data.cell;
        const text = typeof cell.raw === 'string' ? cell.raw : (cell.text || []).join(' ');
        const width = cell.styles.cellWidth;
        if (data.section !== 'body' || !bangla.test(text) || typeof width !== 'number' || cell.colSpan > 1) {
          return;
        }
        const padding = paddingOf(cell);
        const image = this.renderTextImage(text, width - padding * 2, cell.styles.fontSize, cell.styles.fontStyle === 'bold');
        if (!image) {
          return;
        }
        cell.banglaImage = image;
        cell.text = [''];
        cell.styles.minCellHeight = image.heightMm + padding * 2;
      },
      didDrawCell: (data: any) => {
        const image = data.cell.banglaImage;
        if (!image) {
          return;
        }
        const padding = paddingOf(data.cell);
        const freeSpace = Math.max(0, data.cell.height - padding * 2 - image.heightMm);
        const offsetY = data.cell.styles.valign === 'middle' ? freeSpace / 2 : data.cell.styles.valign === 'bottom' ? freeSpace : 0;
        doc.addImage(image.dataUrl, 'PNG', data.cell.x + padding, data.cell.y + padding + offsetY, image.widthMm, image.heightMm);
      },
    };
  }

  // Draws wrapped text with the browser's fonts and returns it as a PNG sized in mm.
  private renderTextImage(
    text: string,
    widthMm: number,
    fontSizePt: number,
    bold: boolean
  ): { dataUrl: string; widthMm: number; heightMm: number } | null {
    const pxPerMm = 12; // ~300 dpi
    const fontPx = fontSizePt * 0.3528 * pxPerMm;
    const lineHeightPx = fontPx * 1.4;
    const widthPx = Math.max(1, Math.floor(widthMm * pxPerMm));
    const font = `${bold ? 'bold ' : ''}${fontPx}px "Noto Sans Bengali", "Nirmala UI", "SolaimanLipi", "Kalpurush", "Vrinda", sans-serif`;

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      return null;
    }
    ctx.font = font;

    // Word wrap; a single word wider than the cell is split by characters.
    const lines: string[] = [];
    String(text).split(/\r?\n/).forEach((paragraph) => {
      let line = '';
      paragraph.split(/\s+/).filter((w) => w).forEach((word) => {
        const candidate = line ? `${line} ${word}` : word;
        if (ctx.measureText(candidate).width <= widthPx) {
          line = candidate;
          return;
        }
        if (line) {
          lines.push(line);
        }
        line = '';
        for (const ch of Array.from(word)) {
          if (line && ctx.measureText(line + ch).width > widthPx) {
            lines.push(line);
            line = '';
          }
          line += ch;
        }
      });
      lines.push(line);
    });

    canvas.width = widthPx;
    canvas.height = Math.ceil(lines.length * lineHeightPx + fontPx * 0.3);
    ctx.font = font; // resizing the canvas resets the context
    ctx.fillStyle = '#000000';
    ctx.textBaseline = 'top';
    lines.forEach((line, index) => ctx.fillText(line, 0, index * lineHeightPx + fontPx * 0.15));

    return {
      dataUrl: canvas.toDataURL('image/png'),
      widthMm: canvas.width / pxPerMm,
      heightMm: canvas.height / pxPerMm,
    };
  }

  downloadSummaryPdf(): void {
    try {
      const doc = new jsPDF('l', 'mm', 'a4');
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const marginX = 14;
      const contentTop = 26; // below the page header
      const contentBottom = 20; // above the page footer
      const confidentialText =
        'Confidential document - for NSDA internal use only';
      const valueOrNA = (value: any) =>
        value != null && String(value).trim() !== '' ? String(value) : 'N/A';
      const lastTableY = () => (doc as any).lastAutoTable.finalY as number;
      const tableMargin = {
        top: contentTop,
        bottom: contentBottom,
        left: marginX,
        right: marginX,
      };
      const headStyles = {
        fillColor: [22, 119, 255] as [number, number, number],
        textColor: 255,
        fontStyle: 'bold' as const,
      };
      const contentWidth = pageWidth - marginX * 2;

      // Report header (first page)
      let y = contentTop + 4;
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(16);
      doc.text('Inspection Summary Report', pageWidth / 2, y, { align: 'center' });
      y += 6;
      doc.setFont('helvetica', 'bolditalic');
      doc.setFontSize(10);
      doc.setTextColor(192, 0, 0);
      doc.text(confidentialText.toUpperCase(), pageWidth / 2, y, {
        align: 'center',
      });
      doc.setTextColor(0, 0, 0);
      y += 8;

      const sectionTitle = (title: string) => {
        if (y > pageHeight - contentBottom - 25) {
          doc.addPage();
          y = contentTop + 4;
        }
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(12);
        doc.text(title, marginX, y);
        y += 3;
      };

      // 1. Inspection details
      sectionTitle('Inspection Details');
      autoTable(doc, {
        startY: y,
        margin: tableMargin,
        theme: 'grid',
        styles: { fontSize: 10, cellPadding: 2 },
        rowPageBreak: 'avoid',
        columnStyles: {
          0: { fontStyle: 'bold', cellWidth: 70, fillColor: [245, 245, 245] },
          1: { cellWidth: contentWidth - 70 },
        },
        ...this.banglaCellHooks(doc),
        body: [
          ['Name of STP/SAC', valueOrNA(this.stpName)],
          ['STP/SAC ID', valueOrNA(this.stpId)],
          ['Application ID', valueOrNA(this.applicationId)],
          ['Date of Application', valueOrNA(this.dateOfApplication)],
          ['Date of Inspection Conducted', valueOrNA(this.dateOfInspectionConducted)],
          ['Inspection Conducted By-1', valueOrNA(this.inspectionConductedBy1)],
          ['Inspection Conducted By-2', valueOrNA(this.inspectionConductedBy2)],
          ['Inspection Conducted By-3', valueOrNA(this.inspectionConductedBy3)],
          ['Inspection Conducted By-4', valueOrNA(this.inspectionConductedBy4)],
        ],
      });
      y = lastTableY() + 10;

      // 2. Representatives present during inspection
      sectionTitle('List of Representatives of STP/SAC Present During Inspection');
      const representatives = (this.representativeList || []).filter(
        (rep: any) => rep?.name
      );
      autoTable(doc, {
        startY: y,
        margin: tableMargin,
        theme: 'grid',
        styles: { fontSize: 10, cellPadding: 2 },
        headStyles,
        head: [['Sl.', 'Name', 'Designation', 'Phone', 'Email']],
        body: representatives.length
          ? representatives.map((rep: any, index: number) => [
              index + 1,
              valueOrNA(rep.name),
              valueOrNA(rep.designation),
              valueOrNA(rep.phone),
              valueOrNA(rep.email),
            ])
          : [[{ content: 'No representative recorded', colSpan: 5, styles: { halign: 'center' } }]],
        rowPageBreak: 'avoid',
        columnStyles: {
          0: { cellWidth: 12, halign: 'center' },
          1: { cellWidth: 70 },
          2: { cellWidth: 65 },
          3: { cellWidth: 40 },
          4: { cellWidth: contentWidth - 187 },
        },
        ...this.banglaCellHooks(doc),
      });
      y = lastTableY() + 10;

      // 3. Summary inspection report (STP/SAC registration only: renewal/reapply has no course rows)
      sectionTitle('Summary Inspection Report');
      const summaryRows: any[] = (this.detailsSummaryReport || []).filter(
        (row: any) => row?.inspectionRegistrationReportId
      );
      autoTable(doc, {
        startY: y,
        margin: tableMargin,
        theme: 'grid',
        styles: { fontSize: 9, cellPadding: 2, valign: 'middle' },
        headStyles: { ...headStyles, halign: 'center' },
        head: [
          [
            'Sl.',
            'Application For',
            'Inspection Result for STP/SAC Registration',
            'STP/SAC Registration Remarks',
          ],
        ],
        body: summaryRows.length
          ? summaryRows.map((row: any, index: number) => [
              index + 1,
              valueOrNA(row.occupationName),
              valueOrNA(row.regInsStpSac),
              valueOrNA(row.inspectorRemarks),
            ])
          : [[{ content: 'No inspection report summary available yet', colSpan: 4, styles: { halign: 'center' } }]],
        rowPageBreak: 'avoid',
        columnStyles: {
          0: { cellWidth: 12, halign: 'center' },
          1: { cellWidth: 70 },
          2: { cellWidth: 70 },
          3: { cellWidth: contentWidth - 152 },
        },
        ...this.banglaCellHooks(doc),
      });

      // Page header and footer on every page
      const generatedOn = this.datepipe.transform(new Date(), 'dd-MM-yyyy hh:mm a');
      const pageCount = doc.getNumberOfPages();
      for (let page = 1; page <= pageCount; page++) {
        doc.setPage(page);

        doc.setFont('helvetica', 'bold');
        doc.setFontSize(13);
        doc.setTextColor(0, 0, 0);
        doc.text('National Skills Development Authority (NSDA)', pageWidth / 2, 13, {
          align: 'center',
        });
        doc.setDrawColor(150);
        doc.setLineWidth(0.4);
        doc.line(marginX, 17, pageWidth - marginX, 17);

        doc.line(marginX, pageHeight - 13, pageWidth - marginX, pageHeight - 13);
        doc.setFontSize(8.5);
        doc.setFont('helvetica', 'italic');
        doc.setTextColor(192, 0, 0);
        doc.text(confidentialText, marginX, pageHeight - 8);
        doc.setTextColor(90, 90, 90);
        doc.setFont('helvetica', 'normal');
        doc.text(`Downloaded on ${generatedOn}`, pageWidth / 2, pageHeight - 8, {
          align: 'center',
        });
        doc.text(`Page ${page} of ${pageCount}`, pageWidth - marginX, pageHeight - 8, {
          align: 'right',
        });
      }

      const fileId = this.applicationId || this.inspectionId || 'report';
      doc.save(`inspection-summary-report-${fileId}.pdf`);
    } catch (e) {
      console.error('Could not create inspection summary PDF', e);
      this.notification.error('Error!', 'Failed to download summary!');
    }
  }
  //#endregion

  disabledDate = (current: Date): boolean =>
    differenceInCalendarDays(current, this.today) > 0;
}
